import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import Footer from "../../Components/Footer/footer";
import { Formik, Form } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import CustomSelect from "../../CustomComponent/custom_select";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcDocument } from "react-icons/fc";
import { useSelector } from "react-redux";
import { SubsidyDocumentsSchema } from "../../Schemas/clients/subsidy_documents.schema";
import { getId } from "../../Components/Functions/word.fun";
import SubsidyDocumentsTable from "./Subsidy Documents/subsidy_documents_table";
import ClientViewDocuments from "./Subsidy Documents/client_view_documents";
import { SubsidyDocumentsInfo } from "../../SchemaInfo/info";
import { useNavigate } from "react-router";
import CustomCheckbox from "../../CustomComponent/custom_checkbox";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";

const SubsidyDocuments = () => {
  const [projects, setProjects] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [userProjectId, setUserProjectId] = useState("");
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const navigate = useNavigate();

  const goToAgrementPage = () => {
    navigate(`/farm-construction/agreement`);
  };

  const handelSubmit = (values) => {
    if (store.Role === process.env.REACT_APP_ROLE_CLIENT) {
      values.clientId = +userProjectId;
    }
    if (!values.clientId) {
      alert("Client details is not available");
    } else {
      let formData = new FormData();
      for (let key in values) {
        formData.append(key, values[key]);
      }
      const headers = { "Content-Type": "multipart/form-data" };

      performRequest(
        "POST",
        "/subsidy-documents/create-subsidy-documents",
        formData,
        headers
      )
        .then((res) => {
          if (res.status === 201) {
            Toast("success", "Documents uploaded successfully!");
            document.getElementById("close-button").click();
            setRefresh(!refresh);
          } else if (res.status === 200) {
            Toast("success", res?.data?.message);
            document.getElementById("close-button").click();
            setRefresh(!refresh);
          } else {
            Toast("error", "Error while uploading data");
            document.getElementById("close-button").click();
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
          document.getElementById("close-button").click();
        })
        .finally(() => setLoading(false));
    }
  };
  useEffect(() => {
    performRequest("GET", "/subsidy-documents/all-subsidy-documents")
      .then((res) => {
        if (store.Role !== process.env.REACT_APP_ROLE_CLIENT) {
          setData(res.data);
        } else {
          for (let i = 0; i < res?.data?.length; i++) {
            if (res.data[i]?.clientProject?.clientEmail === store.Email) {
              setData(res.data[i]);
            }
          }
        }
      })
      .catch((err) => CustomErrorResponse(err));
  }, [store.Role, refresh, store.Email]);
  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => {
        if (store.Role === process.env.REACT_APP_ROLE_CLIENT) {
          for (let i = 0; i < res?.data?.length; i++) {
            if (res.data[i]?.clientEmail === store.Email) {
              setUserProjectId(getId(res.data[i]?.cpNumber));
            }
          }
        } else {
          setProjects(res.data);
        }
      })
      .catch((err) => CustomErrorResponse(err));
  }, [store.Role, store.Email]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcDocument className="fs-2  me-1" /> Subsidy & Documents
                </h2>
                <h4 className="text-muted">
                  <p>Add your workorder, subsidy and documents.</p>
                </h4>
              </div>

              <div className="col-auto ms-auto d-print-none">
                <div className="d-flex d-none d-sm-block">
                  <button
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-team"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M12 5l0 14" />
                      <path d="M5 12l14 0" />
                    </svg>{" "}
                    UPLOAD DOCUMENTS
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2 mb-1">
                <h3 className="m-0 p-0">Documents Details:</h3>
                <hr className="my-1" />
                <div className="p-1">
                  <a
                    href={
                      "https://res.cloudinary.com/bsgfcooa/image/upload/v1753079486/WORK_ORDER_tu2ftq_nwfidm_vv9dkc.pdf"
                    }
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn m-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                        <path d="M9 9l1 0" />
                        <path d="M9 13l6 0" />
                        <path d="M9 17l6 0" />
                      </svg>
                      Work Order
                    </button>
                  </a>
                  <button className="btn m-1" onClick={goToAgrementPage}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                      <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                      <path d="M9 9l1 0" />
                      <path d="M9 13l6 0" />
                      <path d="M9 17l6 0" />
                    </svg>
                    Farm Constuction Agreement
                  </button>
                </div>
              </div>
              <div className="card p-2 mb-1">
                <h3 className="m-0 p-0">AIF Subsidy:</h3>
                <hr className="my-1" />
                <div>
                  <a
                    href={
                      "https://agriinfra.dac.gov.in/Content/DocAttachment/FINALSchemeGuidelinesAIFHindi.pdf"
                    }
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn m-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                        <path d="M9 9l1 0" />
                        <path d="M9 13l6 0" />
                        <path d="M9 17l6 0" />
                      </svg>
                      AIF Guidelines Hindi
                    </button>
                  </a>
                  <a
                    href={
                      "https://agriinfra.dac.gov.in/Content/DocAttachment/FINALSchemeGuidelinesAIF.pdf"
                    }
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn m-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                        <path d="M9 9l1 0" />
                        <path d="M9 13l6 0" />
                        <path d="M9 17l6 0" />
                      </svg>
                      AIF Guidelines English
                    </button>
                  </a>
                  <a
                    href={"https://agriinfra.dac.gov.in/Home/InterestRate"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn m-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                        <path d="M9 9l1 0" />
                        <path d="M9 13l6 0" />
                        <path d="M9 17l6 0" />
                      </svg>
                      AIF Bank Lists
                    </button>
                  </a>
                </div>
              </div>
              <div className="d-none d-lg-block d-md-block mb-2">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/eyt0_Wt-5cQ"}
                  id={"model-viedo"}
                  name={"subsidy & documents"}
                ></CustomViedoCard>
              </div>
              <div className="card p-2 mb-1">
                <h3 className="m-0 p-0">NHB Details:</h3>
                <hr className="my-1" />
                <div>
                  <a
                    href={
                      "https://res.cloudinary.com/bsgfcooa/image/upload/v1753079536/a2spn5pch8ywbhnb7myz_u0cht8_kzx4hb.pdf"
                    }
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn m-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                        <path d="M9 9l1 0" />
                        <path d="M9 13l6 0" />
                        <path d="M9 17l6 0" />
                      </svg>
                      NHB Details
                    </button>
                  </a>
                </div>
              </div>
              <div className="card p-2 mb-1">
                <h3 className="m-0 p-0">Notes:</h3>
                <hr className="my-1" />
                <ul>
                  <li>Aadhar upload is must document without masking.</li>
                  <li>
                    Cast certificate should be issued by government authority.
                  </li>
                  <li>
                    In case of not availability of farmer certificate upload
                    7/12.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              {data &&
                data?.clientId &&
                store.Role === process.env.REACT_APP_ROLE_CLIENT && (
                  <ClientViewDocuments data={data} />
                )}
              <div className="card">
                {(!data || data.length < 1) && (
                  <h3 className="mt-2 text-center">
                    No documents uploaded yet. Please upload your documents
                    here...
                  </h3>
                )}

                {data &&
                  data.length > 1 &&
                  store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                    <SubsidyDocumentsTable
                      documentsData={data}
                      currentPage={1}
                      itemsPerPage={50}
                    />
                  )}
              </div>
            </div>

            <div className="btn-list justify-content-center">
              <div className="d-lg-none d-md-none mt-3 mb-3">
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-team"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>{" "}
                  UPLOAD DOCUMENTS
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal modal-blur fade"
          id="modal-team"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Documents</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <Formik
                initialValues={SubsidyDocumentsInfo}
                validationSchema={SubsidyDocumentsSchema}
                onSubmit={handelSubmit}
              >
                {(props) => (
                  <Form>
                    <div class="modal-body">
                      <div className=" px-4">
                        {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                          <div className="col my-1">
                            <div className="row">
                              <label className="form-label">Client</label>
                              <div className="w-100">
                                <CustomSelect name="clientId" type="number">
                                  <option value="">Select project</option>
                                  {projects &&
                                    projects?.map((pro) => {
                                      return (
                                        <option
                                          key={pro.cpNumber}
                                          value={getId(pro.cpNumber)}
                                        >
                                          {pro.clientName}
                                        </option>
                                      );
                                    })}
                                </CustomSelect>
                                {props.touched.clientId &&
                                  props.errors.clientId && (
                                    <p className="text-danger">
                                      {props.errors.clientId}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col my-1 mt-3 mb-3">
                          <div className="row align-items-center">
                            <label className="form-label col-auto mb-0">
                              Apply for AIF
                            </label>
                            <div className="col-auto ms-3">
                              <CustomCheckbox
                                name="appliedForAIF"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                            </div>
                            {props.touched.appliedForAIF &&
                              props.errors.appliedForAIF && (
                                <p className="text-danger col-12">
                                  {props.errors.appliedForAIF}
                                </p>
                              )}
                          </div>
                        </div>

                        {!props.values.appliedForAIF && (
                          <div className="col my-1">
                            <div className="row">
                              <label className="form-label">Work Order</label>
                              <div className="w-100">
                                {" "}
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "workOrder",
                                      e.target.files[0]
                                    )
                                  }
                                  name="workOrder"
                                  type="file"
                                />
                                {props.touched.workOrder &&
                                  props.errors.workOrder && (
                                    <p className="text-danger">
                                      {props.errors.workOrder}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                        )}
                        {props.values.appliedForAIF && (
                          <>
                            <div className="col my-1">
                              <div className="row">
                                <label className="form-label">
                                  Aadhar card photo front
                                </label>
                                <div className="w-100">
                                  {" "}
                                  <CustomInput
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "aadharcardPhotoFront",
                                        e.target.files[0]
                                      )
                                    }
                                    name="aadharcardPhotoFront"
                                    type="file"
                                  />
                                  {props.touched.aadharcardPhotoFront &&
                                    props.errors.aadharcardPhotoFront && (
                                      <p className="text-danger">
                                        {props.errors.aadharcardPhotoFront}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="col my-1">
                              <div className="row">
                                <label className="form-label">
                                  Aadhar card photo back
                                </label>
                                <div className="w-100">
                                  {" "}
                                  <CustomInput
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "aadharcardPhotoBack",
                                        e.target.files[0]
                                      )
                                    }
                                    name="aadharcardPhotoBack"
                                    type="file"
                                  />
                                  {props.touched.aadharcardPhotoBack &&
                                    props.errors.aadharcardPhotoBack && (
                                      <p className="text-danger">
                                        {props.errors.aadharcardPhotoBack}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="col my-1">
                              <div className="row">
                                <label className="form-label">
                                  Pan card photo
                                </label>
                                <div className="w-100">
                                  {" "}
                                  <CustomInput
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "pancardPhoto",
                                        e.target.files[0]
                                      )
                                    }
                                    name="pancardPhoto"
                                    type="file"
                                  />
                                  {props.touched.pancardPhoto &&
                                    props.errors.pancardPhoto && (
                                      <p className="text-danger">
                                        {props.errors.pancardPhoto}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="col my-1">
                              <div className="row">
                                <label className="form-label">
                                  Cibil report
                                </label>
                                <div className="w-100">
                                  {" "}
                                  <CustomInput
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "cibilReport",
                                        e.target.files[0]
                                      )
                                    }
                                    name="cibilReport"
                                    type="file"
                                  />
                                  {props.touched.cibilReport &&
                                    props.errors.cibilReport && (
                                      <p className="text-danger">
                                        {props.errors.cibilReport}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="col my-1">
                              <div className="row">
                                <label className="form-label">ITR report</label>
                                <div className="w-100">
                                  {" "}
                                  <CustomInput
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "ITRReport",
                                        e.target.files[0]
                                      )
                                    }
                                    name="ITRReport"
                                    type="file"
                                  />
                                  {props.touched.ITRReport &&
                                    props.errors.ITRReport && (
                                      <p className="text-danger">
                                        {props.errors.ITRReport}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="col my-1">
                              <div className="row">
                                <label className="form-label">
                                  Cast certificate
                                </label>
                                <div className="w-100">
                                  {" "}
                                  <CustomInput
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "castCertificate",
                                        e.target.files[0]
                                      )
                                    }
                                    name="castCertificate"
                                    type="file"
                                  />
                                  {props.touched.castCertificate &&
                                    props.errors.castCertificate && (
                                      <p className="text-danger">
                                        {props.errors.castCertificate}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="col my-1">
                              <div className="row">
                                <label className="form-label">
                                  Farmer certificate
                                </label>
                                <div className="w-100">
                                  {" "}
                                  <CustomInput
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "farmerCertificate",
                                        e.target.files[0]
                                      )
                                    }
                                    name="farmerCertificate"
                                    type="file"
                                  />
                                  {props.touched.farmerCertificate &&
                                    props.errors.farmerCertificate && (
                                      <p className="text-danger">
                                        {props.errors.farmerCertificate}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="col my-1">
                              <div className="row">
                                <label className="form-label">
                                  Rental Documents
                                </label>
                                <div className="w-100">
                                  {" "}
                                  <CustomInput
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "rentalDocuments",
                                        e.target.files[0]
                                      )
                                    }
                                    name="rentalDocuments"
                                    type="file"
                                  />
                                  {props.touched.rentalDocuments &&
                                    props.errors.rentalDocuments && (
                                      <p className="text-danger">
                                        {props.errors.rentalDocuments}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        id="close-button"
                        type="button"
                        class="btn me-auto"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <FormSubmitButton buttonText="UPLOAD DOCUMENTS" />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <div className="d-block d-lg-none d-md-none ms-2 me-2">
          <CustomViedoCard
            viedoLink={"https://www.youtube.com/embed/eyt0_Wt-5cQ"}
            id={"model-viedo2"}
            name={"subsidy & documents"}
          ></CustomViedoCard>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default SubsidyDocuments;
